import { Component, signal } from '@angular/core';
import { TopUpRequests } from './tabs/top-up-requests/top-up-requests';
import { PricingModels } from './tabs/pricing-models/pricing-models';
import { Carousel } from './tabs/carousel/carousel';
import { AllActivity } from './tabs/all-activity/all-activity';
import { VideoViews } from './tabs/video-views/video-views';

@Component({
  selector: 'app-god-mode-options',
  imports: [TopUpRequests, PricingModels, Carousel, AllActivity, VideoViews],
  templateUrl: './god-mode-options.html',
  styleUrl: './god-mode-options.scss',
})
export class GodModeOptions {

  /** layout variables */
  selectedTab = signal<'top-up-requests' | 'pricing-models' | 'carousel' | 'all-activity' | 'video-views'>('pricing-models');
  /** layout variables - END */


  getTabClass(tab: 'top-up-requests' | 'pricing-models' | 'carousel' | 'all-activity' | 'video-views') {
    return this.selectedTab() === tab
      ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200'
      : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }
}
